import React, { FC } from 'react';
import classNames from 'classnames/bind';
import { SocialType } from 'sections/Company/ContactUs/types';
import styles from 'sections/Company/ContactUs/components/Contact/InfoErp/InfoErp.module.scss';

const cn = classNames.bind(styles);

interface InfoErpProps {
  social: SocialType;
}

const InfoErp: FC<InfoErpProps> = ({ social }): React.ReactElement => {
  const socialElements = Object.entries(social).map(([key, value], index) => {
    return (
      <li
        className={cn('social__item')}
        key={`${value}_${index}`}
      >
        <a className={cn('social__item-link')} href={value}>
          <img
            src={`/images/pages/Company/ContactUs/${key}.svg`}
            alt={`${key} icon`}
          />
        </a>
      </li>
    );
  });

  return (
    <div className={cn('info-erp')}>
      <h2 className={cn('info-erp__heading')}>Channel Partner Program</h2>

      <p className={cn('info-erp__description')}>
        Whether you’re a technology consultant, software provider, or part of the management consulting ecosystem,
        partnering with SR ERP allows you to unlock new revenue streams, expand your service offerings, and enhance your
        market positioning.
      </p>

      <ul className={cn('social')}>{socialElements}</ul>
    </div>
  );
};

export { InfoErp };
